export default __webpack_public_path__ + "static/Tek_Jump_Pad-d73a997031d8ea2b2de987a0b98a63fe.png";